export default "__VITE_ASSET__CFNz6kUr__"